<template>
  <main id="quote" class="page-container" v-if="$route.name === 'quotes'">
    <!-- <p
      v-if="errorMessage"
      :class="{ 'error-message': true, show: errorMessage }"
    >
      {{ errorMessage }}
    </p>
    <p
      v-if="successMessage"
      :class="{ 'success-message': true, show: successMessage }"
    >
      {{ successMessage }}
    </p> -->
    <div class="table-container-quote">
      <div class="quotes-toolbar">
        <router-link to="/home/quotes/add-quote" class="primary-btn">
          + Nuovo preventivo
        </router-link>
      </div>

      <!-- BARRA DI RICERCA -->
      <div class="search-container">
        <input
          type="text"
          v-model="searchQuery"
          placeholder="Cerca preventivo per nome cliente, evento, luogo..."
          class="search-box"
          @input="handleSearch"
        />
        <button
          v-if="searchQuery"
          @click="clearSearch"
          class="clear-search-button"
          title="Cancella ricerca"
        >
          <font-awesome-icon :icon="['fas', 'xmark']" />
        </button>
      </div>

      <div class="tbl-wrap">
        <table class="tbl quote-table">
          <thead>
            <tr>
              <th>Operatore</th>
              <th @click="setSort('clientName')" class="sortable-th">
                Nome cliente
                <span class="sort-indicator">{{
                  sortIndicator("clientName")
                }}</span>
              </th>
              <th
                @click="setSort('totalPriceWithoutSubItems')"
                class="sortable-th"
              >
                Prezzo
                <span class="sort-indicator">{{
                  sortIndicator("totalPriceWithoutSubItems")
                }}</span>
              </th>
              <th @click="setSort('rentStartDate')" class="sortable-th">
                Data
                <span class="sort-indicator">{{
                  sortIndicator("rentStartDate")
                }}</span>
              </th>
              <th @click="setSort('eventName')" class="sortable-th">
                Nome evento
                <span class="sort-indicator">{{
                  sortIndicator("eventName")
                }}</span>
              </th>
              <th id="luogo">Luogo</th>
              <th id="ultimo-preventivo">Documenti</th>
              <th @click="setSort('state')" class="sortable-th">
                Stato
                <span class="sort-indicator">{{ sortIndicator("state") }}</span>
              </th>
              <th @click="setSort('createdAt')" class="sortable-th">
                Creato
                <span class="sort-indicator">{{
                  sortIndicator("createdAt")
                }}</span>
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <!-- template per generare due <tr> per ogni quote -->
            <template v-for="(quote, index) in paginatedQuotes" :key="index">
              <!-- riga con i dati e le icone in versione desktop -->
              <tr
                class="quote-row"
                :id="'quote-row-' + quote.id"
                :class="{
                  'quote-row--highlighted': quote.id === highlightedQuoteId,
                }"
              >
                <td class="operators-cell">
                  <span
                    v-for="(op, opIdx) in quote.operators"
                    :key="opIdx"
                    class="operator-chip"
                    @click.stop="toggleOperatorBadge(`${quote.id}-${opIdx}`)"
                  >
                    {{ op.operatorName }}
                    <span
                      v-if="op.email"
                      class="operator-email-badge"
                      :class="{
                        'operator-email-badge--visible':
                          activeOperatorBadge === `${quote.id}-${opIdx}`,
                      }"
                    >
                      {{ op.email }}
                    </span>
                  </span>
                </td>
                <td>{{ quote.Client.clientName }}</td>
                <td>
                  {{ formatPriceToPrint(quote.totalPriceWithoutSubItems) }}
                </td>
                <td>
                  <em>inizio</em> {{ formatToLocalDate(quote.rentStartDate) }} -
                  <em>fine</em> {{ formatToLocalDate(quote.rentEndDate) }} ({{
                    quote.daysCount
                  }})
                </td>
                <td>{{ quote.eventName }}</td>
                <td>
                  <a
                    id="link-luogo"
                    v-if="quote.location && quote.location.link"
                    :href="quote.location.link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {{ quote.location.address || "Indirizzo non disponibile" }}
                  </a>
                  <span v-else>Indirizzo non disponibile</span>
                </td>
                <td>
                  <span id="open-file" @click="openDocumentsModal(quote)">
                    <font-awesome-icon :icon="['fas', 'fa-file']" />
                    Apri file
                  </span>
                  <button
                    v-if="needsRegenPdf(quote)"
                    class="regen-pdf-badge"
                    :disabled="regeningPdfFor === quote.id"
                    @click.stop="regenQuotePdf(quote)"
                    title="Gli operatori hanno modificato la lista materiali — clicca per rigenerare il PDF"
                  >
                    <font-awesome-icon
                      v-if="regeningPdfFor === quote.id"
                      :icon="['fas', 'spinner']"
                      spin
                    />
                    <font-awesome-icon
                      v-else
                      :icon="['fas', 'triangle-exclamation']"
                    />
                    {{
                      regeningPdfFor === quote.id
                        ? "Generando..."
                        : "Rigenera PDF"
                    }}
                  </button>
                </td>
                <td class="status-container">
                  <div class="status-wrapper">
                    <svg
                      :class="[
                        'status-icon',
                        { sent: quote.state === 'Inviato' },
                        { accepted: quote.state === 'Accettato' },
                        { 'in-delivery': quote.state === 'In consegna' },
                        { closed: quote.state === 'Chiuso' },
                      ]"
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                    >
                      <path
                        d="M15 7.5C15 11.6421 11.6421 15 7.5 15C3.35786 15 0 11.6421 0 7.5C0 3.35786 3.35786 0 7.5 0C11.6421 0 15 3.35786 15 7.5Z"
                      />
                    </svg>
                    <select
                      :value="quote.state"
                      :disabled="quote.state === 'Chiuso'"
                      @change="promptStateChange(quote, $event.target.value)"
                    >
                      <option
                        value="Inviato"
                        :disabled="quote.state !== 'Inviato'"
                      >
                        Inviato
                      </option>

                      <option
                        value="Accettato"
                        :disabled="quote.state !== 'Inviato'"
                      >
                        Accettato
                      </option>

                      <option
                        value="In consegna"
                        :disabled="quote.state !== 'Accettato'"
                      >
                        {{
                          quote.state === "In consegna"
                            ? "In consegna"
                            : "Conferma partenza"
                        }}
                      </option>

                      <option
                        value="Chiuso"
                        :disabled="quote.state !== 'In consegna'"
                      >
                        {{
                          quote.state === "Chiuso"
                            ? "Materiale rientrato"
                            : "Rientro materiale"
                        }}
                      </option>
                    </select>
                  </div>

                  <span v-if="hasWarningItems(quote)" class="warning-badge">
                    In attesa rientro
                  </span>
                </td>

                <td>{{ formatToLocalDate(quote.createdAt) }}</td>

                <td class="actions-cell">
                  <button
                    class="icons-button"
                    @click="openItemsModal(quote)"
                    title="Articoli impegnati"
                    aria-label="Articoli impegnati"
                  >
                    <font-awesome-icon :icon="['fas', 'list']" />
                  </button>
                  <button
                    class="icons-button"
                    @click="goToEditQuote(quote.id)"
                    title="Modifica preventivo"
                    aria-label="Modifica preventivo"
                  >
                    <font-awesome-icon :icon="['fas', 'pen-to-square']" />
                  </button>
                  <button
                    class="icons-button"
                    @click="promptArchive(quote)"
                    title="Archivia preventivo"
                    aria-label="Archivia preventivo"
                  >
                    <font-awesome-icon :icon="['fas', 'trash-can']" />
                  </button>
                  <button
                    class="icons-button"
                    @click="promptCalendar(quote)"
                    title="Aggiungi al calendario aziendale"
                    aria-label="Aggiungi al calendario aziendale"
                  >
                    <font-awesome-icon :icon="['fas', 'calendar-days']" />
                  </button>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
        <!-- MESSAGGI PER NESSUN RISULTATO -->
        <div
          v-if="filteredQuotes.length === 0 && searchQuery"
          class="no-results"
        >
          <p>Nessun preventivo trovato per "{{ searchQuery }}"</p>
        </div>
        <div v-else-if="filteredQuotes.length === 0" class="no-items">
          <p>Nessun preventivo disponibile</p>
        </div>
      </div>

      <!-- PAGINAZIONE -->
      <div v-if="showPagination" class="pagination-container">
        <div class="pagination-info">
          Mostrando {{ startItem }}-{{ endItem }} di
          {{ sortedQuotes.length }} preventivi
        </div>

        <div class="pagination-controls">
          <button
            @click="prevPage"
            :disabled="currentPage === 1"
            class="pagination-btn"
          >
            ‹ Precedente
          </button>

          <div class="page-numbers">
            <button
              v-for="page in visiblePages"
              :key="page"
              @click="goToPage(page)"
              :class="{
                'page-btn': true,
                active: page === currentPage,
              }"
            >
              {{ page }}
            </button>

            <span v-if="showEllipsis" class="ellipsis">...</span>
          </div>

          <button
            @click="nextPage"
            :disabled="currentPage === totalPages"
            class="pagination-btn"
          >
            Successiva ›
          </button>
        </div>

        <div class="pagination-size">
          <label for="pageSize">Preventivi per pagina:</label>
          <select
            id="pageSize"
            v-model="pageSize"
            @change="onPageSizeChange"
            class="page-size-select"
          >
            <option :value="10">10</option>
            <option :value="25">25</option>
            <option :value="50">50</option>
            <option :value="100">100</option>
          </select>
        </div>
      </div>

      <!-- ▸ MODALE ARCHIVIAZIONE PREVENTIVO -->
      <div v-if="showArchiveModal" class="modal-overlay">
        <div class="modal">
          <button
            class="modal__close icons-button"
            @click="cancelArchive"
            title="Chiudi"
            aria-label="Chiudi"
          >
            <font-awesome-icon :icon="['fas', 'xmark']" />
          </button>
          <h3 class="modal__title">Archivia preventivo</h3>
          <p class="modal__subtitle">
            Sei sicuro di voler archiviare il preventivo
            <strong>{{ selectedQuote?.Client?.clientName }}</strong
            >?
          </p>
          <div class="modal-actions">
            <button class="primary-btn" @click="confirmArchive">
              Archivia
            </button>
            <!-- <button class="secondary-btn" @click="cancelArchive">Annulla</button> -->
          </div>
        </div>
      </div>

      <!-- ▸ MODALE CONFERMA AGGIUNTA AL CALENDARIO AZIENDALE -->
      <div v-if="showCalendarModal" class="modal-overlay">
        <div class="modal">
          <button
            class="modal__close icons-button"
            @click="cancelCalendar"
            title="Chiudi"
            aria-label="Chiudi"
            :disabled="isAddingToCalendar"
          >
            <font-awesome-icon :icon="['fas', 'xmark']" />
          </button>
          <h3 class="modal__title">Aggiungi al calendario aziendale</h3>
          <p class="modal__subtitle">
            Vuoi aggiungere il preventivo
            <strong>{{ selectedQuote?.eventName }}</strong>
            ({{ selectedQuote?.Client?.clientName }}) al calendario aziendale?
          </p>
          <div class="modal-actions">
            <button
              class="primary-btn"
              @click="confirmCalendar"
              :disabled="isAddingToCalendar"
            >
              <font-awesome-icon
                v-if="isAddingToCalendar"
                :icon="['fas', 'spinner']"
                spin
              />
              {{ isAddingToCalendar ? "Aggiunta in corso..." : "Aggiungi" }}
            </button>
          </div>
        </div>
      </div>

      <!-- ▸ MODALE CAMBIO STATO -->
      <div v-if="showStateModal" class="modal-overlay">
        <div class="modal">
          <button
            class="modal__close icons-button"
            @click="cancelStateChange"
            title="Chiudi"
            aria-label="Chiudi"
          >
            <font-awesome-icon :icon="['fas', 'xmark']" />
          </button>
          <h3 class="modal__title">Cambio stato</h3>
          <div v-if="newState !== 'Chiuso'">
            <p class="modal__subtitle">
              Vuoi confermare il cambio di stato del preventivo
              <strong>{{ selectedQuoteId }}</strong>
              da <strong>{{ currentState }}</strong> a
              <strong>{{ newState }}</strong
              >?
            </p>
            <div
              v-if="newState === 'Accettato' && lowStockItems.length > 0"
              class="low-stock-warning"
            >
              <p class="low-stock-warning__title">
                <strong
                  >Attenzione: materiale non ancora rientrato in
                  magazzino</strong
                >
              </p>
              <ul class="low-stock-warning__list">
                <li v-for="item in lowStockItems" :key="item.itemId">
                  {{ item.itemName }} (disponibili in magazzino:
                  {{ item.inWarehouse }})
                </li>
              </ul>
              <p class="low-stock-warning__note">
                Confermando, il preventivo verrà accettato anche se il materiale
                non è ancora disponibile.
              </p>
            </div>
          </div>

          <!-- Contenuto specifico per stato "Chiuso" -->
          <div v-else>
            <p class="modal__subtitle">
              Vuoi confermare il cambio di stato del preventivo
              <strong>{{ selectedQuoteId }}</strong>
              da <strong>{{ currentState }}</strong> a
              <strong>{{ newState }}</strong
              >?
            </p>

            <div class="damage-report-section">
              <p class="damage-report-title">
                <strong>Segnala articoli danneggiati o persi:</strong>
              </p>
              <p v-if="quoteItems.length === 0" style="color: orange">
                Caricamento articoli in corso... ({{ quoteItems.length }}
                articoli trovati)
              </p>
              <div
                v-for="item in quoteItems"
                :key="item.id"
                class="damage-report-item"
              >
                <div class="damage-item-header">
                  <input
                    type="checkbox"
                    :id="`damage-${item.itemId}`"
                    @change="toggleDamageItem(item)"
                  />
                  <label :for="`damage-${item.itemId}`">
                    {{ item.itemName }} (Q.tà preventivo: {{ item.quantity }})
                  </label>
                </div>
                <!-- Input per quantità danneggiata (visibile solo se selezionato) -->
                <div v-if="isItemDamaged(item.itemId)" class="damage-quantity">
                  <label>Quantità danneggiata/persa:</label>
                  <input
                    type="number"
                    :min="1"
                    :max="item.quantity"
                    v-model="getDamagedItem(item.itemId).damagedQuantity"
                    class="quantity-input"
                  />
                  <span class="quantity-info"
                    >/ {{ item.quantity }} totali</span
                  >
                </div>
              </div>
              <p v-if="damagedItems.length > 0" class="damage-report-note">
                {{ getTotalDamagedCount() }} articolo/i selezionato/i.
              </p>
              <p v-if="damagedItems.length > 0" class="damage-report-note">
                Gli articoli selezionati non verranno restituiti al magazzino.
              </p>
            </div>
          </div>
          <div class="modal-actions">
            <button class="primary-btn" @click="confirmStateChange">
              Conferma
            </button>
            <!-- <button class="secondary-btn" @click="cancelStateChange">
            Annulla
          </button> -->
          </div>
        </div>
      </div>

      <!-- ▸ MODALE CONFERMA PARTENZA MATERIALE -->
      <div v-if="showDeliveryModal" class="modal-overlay">
        <div class="modal">
          <button
            class="modal__close icons-button"
            @click="cancelDelivery"
            title="Chiudi"
            aria-label="Chiudi"
          >
            <font-awesome-icon :icon="['fas', 'xmark']" />
          </button>
          <h3 class="modal__title">Conferma partenza materiale</h3>
          <p class="modal__subtitle">
            Vuoi confermare la partenza del materiale per il preventivo
            <strong>{{ selectedQuoteId }}</strong
            >?
          </p>
          <p class="modal__subtitle">
            Data inizio noleggio:
            <strong>{{
              formatToLocalDate(selectedQuote?.rentStartDate)
            }}</strong>
          </p>
          <div v-if="isDeliveryDateInFuture" class="low-stock-warning">
            <p class="low-stock-warning__title">
              <strong
                >Attenzione: la data di inizio noleggio non è ancora
                arrivata.</strong
              >
            </p>
            <p class="low-stock-warning__note">
              Il server bloccherà l'operazione finché non si raggiunge la data
              indicata.
            </p>
          </div>
          <div class="modal-actions">
            <button class="primary-btn" @click="confirmDelivery">
              Conferma partenza
            </button>
          </div>
        </div>
      </div>

      <!-- MODALE PER DOCUMENTI -->
      <VueFinalModal
        v-model="showDocumentsModal"
        :clickToClose="true"
        :escToClose="true"
        classes="documents-modal"
        content-class="documents-modal-content"
      >
        <template #default>
          <!-- Overlay firma in corso -->
          <div v-if="isSigning" class="docs-signing-overlay">
            <font-awesome-icon
              :icon="['fas', 'spinner']"
              spin
              class="docs-signing-spinner"
            />
            <span>Firma in corso...</span>
          </div>

          <button
            class="modal__close icons-button"
            @click="closeDocumentsModal"
          >
            <font-awesome-icon :icon="['fas', 'xmark']" />
          </button>
          <h3 class="modal__title">Documenti associati</h3>
          <!-- <hr class="modal-hr" /> -->
          <div class="documents-search">
            <div class="search-wrapper">
              <font-awesome-icon
                class="search-icon"
                :icon="['fas', 'magnifying-glass']"
              />
              <input
                type="text"
                v-model="searchTerm"
                placeholder="Cerca un documento..."
                class="search-doc-input"
              />
            </div>
          </div>

          <transition-group name="card" tag="div" class="documents-grid">
            <div
              v-for="doc in filteredDocuments || []"
              :key="doc.id"
              class="document-card"
            >
              <a :href="doc.url" target="_blank" class="card-link">
                <div class="card-icon">
                  <!-- Icona PDF preventivo/lista_materiali -->
                  <font-awesome-icon
                    :icon="
                      doc.name.startsWith('lista_materiali')
                        ? ['fas', 'list-check']
                        : ['fas', 'file-pdf']
                    "
                    size="2x"
                  />
                </div>
                <div class="card-body">
                  <div class="card-title">{{ formatDocName(doc.name) }}</div>
                  <div class="card-subtitle">
                    <!-- ad esempio la data -->
                    {{ formatToLocalDate(doc.createdAt) }}
                  </div>
                </div>
              </a>
              <button
                v-if="doc.name.startsWith('preventivo_')"
                class="sign-doc-btn"
                :disabled="isSigning"
                @click="openSignModal(doc)"
                title="Firma questo documento"
              >
                <font-awesome-icon :icon="['fas', 'pen-nib']" />
                Firma
              </button>
            </div>
            <div v-if="filteredDocuments.length === 0" class="no-result">
              Nessun documento trovato
            </div>
          </transition-group>
        </template>
      </VueFinalModal>

      <!-- MODALE FIRMA ELETTRONICA -->
      <VueFinalModal
        v-model="showSignModal"
        :clickToClose="false"
        :escToClose="false"
        classes="sign-modal"
        content-class="sign-modal-content"
      >
        <template #default>
          <SignaturePad
            :title="docToSign ? formatDocName(docToSign.name) : ''"
            @confirm="embedAndUpload"
            @cancel="showSignModal = false"
          />
        </template>
      </VueFinalModal>
    </div>

    <!-- MODALE ARTICOLI IMPEGNATI -->
    <div
      v-if="showItemsModal"
      class="modal-overlay"
      @click.self="showItemsModal = false"
    >
      <div class="modal items-modal">
        <button
          class="modal__close icons-button"
          @click="showItemsModal = false"
          aria-label="Chiudi"
        >
          <font-awesome-icon :icon="['fas', 'xmark']" />
        </button>
        <h3 class="modal__title">Articoli impegnati</h3>
        <p class="modal__subtitle">{{ selectedModalQuote?.eventName }}</p>
        <hr class="modal-hr" />

        <p v-if="selectedQuoteItems.length === 0" class="items-modal__empty">
          Nessun articolo registrato.
        </p>

        <div v-else class="items-modal__body">
          <table class="items-modal__table">
            <thead>
              <tr>
                <th>Nome articolo</th>
                <th>Quantità</th>
                <th>Stato</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in selectedQuoteItems"
                :key="item.id"
                :class="{ 'items-modal__row--warning': item.isWarningItem }"
              >
                <td>{{ item.item?.itemName ?? "—" }}</td>
                <td>{{ item.quantity }}</td>
                <td>
                  <template v-if="item.isWarningItem">
                    <span class="warning-badge">In attesa rientro</span>
                    <div
                      v-if="earliestBlockingQuote(item.item?.id)"
                      class="items-modal__blocking-date"
                    >
                      in uso dal
                      {{
                        formatToLocalDate(
                          earliestBlockingQuote(item.item?.id).rentStartDate
                        )
                      }}
                      al
                      {{
                        formatToLocalDate(
                          earliestBlockingQuote(item.item?.id).rentEndDate
                        )
                      }}
                      (<button
                        class="items-modal__blocking-link"
                        @click="
                          focusBlockingQuote(
                            earliestBlockingQuote(item.item?.id).id
                          )
                        "
                      >
                        prev. #{{
                          earliestBlockingQuote(item.item?.id).id
                        }}</button
                      >)
                    </div>
                  </template>
                  <span v-else>—</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-if="selectedQuoteItems.length > 0" class="items-modal__footer">
          <span>{{ selectedQuoteItems.length }} articoli totali</span>
          <span v-if="warningItemsCount > 0" class="warning-badge">
            {{ warningItemsCount }} in attesa rientro
          </span>
        </div>
      </div>
    </div>
  </main>
  <router-view></router-view>
</template>

<script>
import { useToast } from "vue-toast-notification";
import { mapActions, mapGetters } from "vuex/dist/vuex.cjs.js";
import { VueFinalModal } from "vue-final-modal";
import SignaturePad from "../components/SignaturePad.vue";
import axiosInstance from "../axiosInstance";
import { formatPriceToPrint, formatToLocalDate } from "../utilities/formatting";
import { jsPDF } from "jspdf";
import logoPath from "@/assets/4AllEvent_logo.png";

export default {
  components: { VueFinalModal, SignaturePad },
  setup() {
    const toast = useToast();
    return { toast };
  },
  computed: {
    ...mapGetters({
      allQuotes: "quotes/list",
    }),

    selectedQuoteItems() {
      return this.selectedModalQuote?.quote_items ?? [];
    },

    isDeliveryDateInFuture() {
      if (!this.selectedQuote?.rentStartDate) return false;
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const startDate = new Date(this.selectedQuote.rentStartDate);
      startDate.setHours(0, 0, 0, 0);
      return startDate > today;
    },

    warningItemsCount() {
      return this.selectedQuoteItems.filter((i) => i.isWarningItem).length;
    },

    // RICERCA
    filteredQuotes() {
      if (!this.searchQuery) return this.allQuotes;
      const query = this.searchQuery.toLowerCase().trim();
      return this.allQuotes.filter((quote) => {
        const operatorName = quote.operators
          .map((op) => op.operatorName)
          .join(", ");
        const clientName = quote.Client?.clientName?.toLowerCase() || "";
        const eventName = quote.eventName?.toLowerCase() || "";
        const location = quote.location?.address?.toLowerCase() || "";
        const state = quote.state?.toLowerCase() || "";
        return (
          operatorName.includes(query) ||
          clientName.includes(query) ||
          eventName.includes(query) ||
          location.includes(query) ||
          state.includes(query) ||
          (quote.id && quote.id.toString().includes(query))
        );
      });
    },

    // ORDINAMENTO
    sortedQuotes() {
      if (!this.sortKey) return this.filteredQuotes;
      return [...this.filteredQuotes].sort((a, b) => {
        let aVal, bVal;
        if (this.sortKey === "clientName") {
          aVal = a.Client?.clientName?.toLowerCase() || "";
          bVal = b.Client?.clientName?.toLowerCase() || "";
        } else {
          aVal = a[this.sortKey] ?? "";
          bVal = b[this.sortKey] ?? "";
        }
        if (aVal < bVal) return this.sortOrder === "asc" ? -1 : 1;
        if (aVal > bVal) return this.sortOrder === "asc" ? 1 : -1;
        return 0;
      });
    },

    // PAGINAZIONE
    totalPages() {
      return Math.ceil(this.sortedQuotes.length / this.pageSize);
    },

    paginatedQuotes() {
      const start = (this.currentPage - 1) * this.pageSize;
      return this.sortedQuotes.slice(start, start + this.pageSize);
    },

    showPagination() {
      return this.sortedQuotes.length > 0;
    },

    startItem() {
      return (this.currentPage - 1) * this.pageSize + 1;
    },

    endItem() {
      const end = this.currentPage * this.pageSize;
      return end > this.sortedQuotes.length ? this.sortedQuotes.length : end;
    },

    visiblePages() {
      const pages = [];
      const maxVisible = 5;
      let start = Math.max(1, this.currentPage - Math.floor(maxVisible / 2));
      let end = Math.min(this.totalPages, start + maxVisible - 1);

      // Adjust start if we're near the end
      start = Math.max(1, end - maxVisible + 1);

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      return pages;
    },

    showEllipsis() {
      return this.totalPages > this.visiblePages[this.visiblePages.length - 1];
    },

    filteredDocuments() {
      if (!this.selectedDocuments || !Array.isArray(this.selectedDocuments)) {
        return [];
      }

      const filtered = this.selectedDocuments
        .filter((doc) =>
          (doc.name || "")
            .replace(/\.dev(?=\.pdf$)/, "")
            .replace(/_N_\d+\.pdf$/, "")
            .toLowerCase()
            .includes((this.searchTerm || "").toLowerCase())
        )
        .slice(0, 3);

      return filtered;
    },
  },
  data() {
    return {
      // quotes: [],
      // errorMessage: "",
      // successMessage: "",
      searchTerm: "",
      // filteredDocuments: [],
      showDocumentsModal: false,
      selectedDocuments: [],
      showArchiveModal: false,
      showStateModal: false,
      showDeliveryModal: false,
      showCalendarModal: false,
      isAddingToCalendar: false,
      selectedQuote: null,
      selectedQuoteId: null,
      currentState: null,
      newState: null,
      searchQuery: "",
      currentPage: 1,
      pageSize: 25,
      quoteItems: [],
      damagedItems: [],
      lowStockItems: [],
      sortKey: "",
      sortOrder: "asc",
      showItemsModal: false,
      selectedModalQuote: null,
      highlightedQuoteId: null,
      activeOperatorBadge: null,
      regeningPdfFor: null,
      selectedDocQuoteId: null,
      showSignModal: false,
      docToSign: null,
      isSigning: false,
    };
  },
  watch: {
    searchQuery() {
      this.currentPage = 1;
    },
    allQuotes() {
      this.currentPage = 1;
    },
  },
  methods: {
    // Mappa l'azione fetchQuotes e archiveQuote
    ...mapActions(["fetchQuotes", "archiveQuote", "addQuoteToCalendar"]),

    toggleOperatorBadge(key) {
      this.activeOperatorBadge = this.activeOperatorBadge === key ? null : key;
    },
    closeOperatorBadge() {
      this.activeOperatorBadge = null;
    },

    formatToLocalDate,

    formatPriceToPrint,

    // Rimuove “_N_<numero>.pdf” dalla fine, lasciando solo il prefisso
    formatDocName(name) {
      return name
        .replace(/.dev(?=\.pdf$)/, "") // rimuove .dev.pdf → .pdf
        .replace(/_N_\d+\.pdf$/, "");
    },

    // RICERCA E PAGINAZIONE
    handleSearch() {
      // La ricerca avviene automaticamente grazie alla computed property filteredQuotes
    },

    clearSearch() {
      this.searchQuery = "";
    },

    setSort(key) {
      if (this.sortKey === key) {
        this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
      } else {
        this.sortKey = key;
        this.sortOrder = "asc";
      }
      this.currentPage = 1;
    },

    sortIndicator(key) {
      if (this.sortKey !== key) return "⇅";
      return this.sortOrder === "asc" ? "▲" : "▼";
    },

    // METODI PAGINAZIONE
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.scrollToTop();
      }
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.scrollToTop();
      }
    },

    goToPage(page) {
      this.currentPage = page;
      this.scrollToTop();
    },

    onPageSizeChange() {
      this.currentPage = 1;
    },

    scrollToTop() {
      const tableContainer = document.querySelector(".tbl-wrap");
      if (tableContainer) {
        tableContainer.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    },

    openDocumentsModal(quote) {
      this.selectedDocQuoteId = quote.id;
      this.showDocumentsModal = true;
      this.selectedDocuments = Array.isArray(quote.documents)
        ? quote.documents
        : [];
    },

    closeDocumentsModal() {
      this.showDocumentsModal = false;
      this.selectedDocuments = [];
      this.searchTerm = "";
      this.selectedDocQuoteId = null;
    },

    async getQuotes() {
      // this.successMessage = "";
      // this.errorMessage = "";
      try {
        await this.fetchQuotes();
        // console.log("fetchQuotes: ", this.allQuotes);
      } catch (error) {
        // this.$nextTick(() => {
        // this.errorMessage =
        this.toast.error(error.response?.data?.details);
        /*||"Errore durante la visualizzazione dei preventivi."*/
        // });
      }
    },

    promptCalendar(quote) {
      this.selectedQuoteId = quote.id;
      this.selectedQuote = quote;
      this.showCalendarModal = true;
    },

    cancelCalendar() {
      if (this.isAddingToCalendar) return;
      this.showCalendarModal = false;
      this.selectedQuoteId = null;
      this.selectedQuote = null;
    },

    async confirmCalendar() {
      this.isAddingToCalendar = true;
      try {
        await this.addQuoteToCalendar(this.selectedQuoteId);
        this.toast.success("Evento aggiunto al calendario aziendale!");
        this.showCalendarModal = false;
        this.selectedQuoteId = null;
        this.selectedQuote = null;
      } catch (error) {
        this.toast.error(
          error.response?.data?.details ||
            error.response?.data?.message ||
            "Errore durante l'aggiunta al calendario."
        );
      } finally {
        this.isAddingToCalendar = false;
      }
    },

    goToEditQuote(quoteId) {
      this.$router.push({ name: "edit-quote", params: { quoteId } });
    },

    promptArchive(quote) {
      this.selectedQuoteId = quote.id;
      this.selectedQuote = quote;
      this.showArchiveModal = true;
    },

    // Conferma archiviazione
    async confirmArchive() {
      try {
        const response = await this.archiveQuote(this.selectedQuoteId);
        if (response.status === 200) {
          // this.successMessage =
          this.toast.success(
            response.data?.message || "Preventivo archiviato con successo."
          );
        }
      } catch (err) {
        console.error(err);
        // this.errorMessage =
        this.toast.error(
          err.response?.data?.details ||
            err.response?.data?.error ||
            "Impossibile archiviare il preventivo."
        );
      } finally {
        this.showArchiveModal = false;
        this.selectedQuoteId = null;
        this.getQuotes();
      }
    },

    cancelArchive() {
      this.showArchiveModal = false;
      this.selectedQuoteId = null;
    },

    // Cambio stato
    async promptStateChange(quote, state) {
      // Transizione Accettato → In consegna: usa endpoint dedicato
      if (state === "In consegna") {
        this.selectedQuoteId = quote.id;
        this.selectedQuote = quote;
        this.showDeliveryModal = true;
        return;
      }

      this.selectedQuoteId = quote.id;
      this.selectedQuote = quote;
      this.currentState = quote.state;
      this.newState = state;
      this.quoteItems = [];
      this.lowStockItems = [];
      // Se lo stato è "Chiuso" o "Accettato", carica gli articoli del preventivo
      if (state === "Chiuso" || state === "Accettato") {
        try {
          const response = await axiosInstance.get(`/quote/${quote.id}`);
          console.log("response: ", response);
          const quoteData = response.data.quote;

          // Usa quote_items che contiene le informazioni complete
          const quoteItems = quoteData.quote_items.map((qi) => ({
            id: qi.id,
            itemId: qi.item?.id,
            itemName: qi.item?.itemName,
            quantity: qi.quantity,
            price: qi.price,
            area: qi.area,
            inWarehouse: qi.item?.inWarehouse ?? 0,
            isWarningItem: qi.isWarningItem ?? false,
          }));

          // Raggruppo con Map
          const mergedItemsMap = new Map();

          for (const item of quoteItems) {
            if (!item.itemId) continue; // skip se manca itemId

            if (!mergedItemsMap.has(item.itemId)) {
              mergedItemsMap.set(item.itemId, {
                itemId: item.itemId,
                itemName: item.itemName,
                quantity: 0,
                inWarehouse: item.inWarehouse,
                isWarningItem: false,
              });
            }

            const existing = mergedItemsMap.get(item.itemId);
            existing.quantity += item.quantity;
            if (item.isWarningItem) existing.isWarningItem = true;
          }

          // Converto la Map in array
          this.quoteItems = Array.from(mergedItemsMap.values());

          if (state === "Accettato") {
            this.lowStockItems = this.quoteItems.filter(
              (item) => item.isWarningItem === true
            );
          }

          console.log("Articoli raggruppati:", this.quoteItems);
        } catch (error) {
          // console.error("Errore nel caricamento articoli:", error);
          this.quoteItems = [];
          this.lowStockItems = [];
        }
      } else {
        this.quoteItems = [];
      }
      this.showStateModal = true;
    },

    openItemsModal(quote) {
      this.selectedModalQuote = quote;
      this.showItemsModal = true;
    },

    earliestBlockingQuote(itemId) {
      const candidates = (this.allQuotes ?? []).filter(
        (q) =>
          q.id !== this.selectedModalQuote?.id &&
          q.state !== "Chiuso" &&
          Array.isArray(q.quote_items) &&
          q.quote_items.some((qi) => qi.item?.id === itemId)
      );
      if (!candidates.length) return null;
      candidates.sort(
        (a, b) => new Date(a.rentStartDate) - new Date(b.rentStartDate)
      );
      return candidates[0];
    },

    focusBlockingQuote(quoteId) {
      this.showItemsModal = false;
      const index = this.sortedQuotes.findIndex((q) => q.id === quoteId);
      if (index === -1) return;
      const targetPage = Math.floor(index / this.pageSize) + 1;
      this.currentPage = targetPage;
      this.highlightedQuoteId = quoteId;
      this.$nextTick(() => {
        const row = document.getElementById(`quote-row-${quoteId}`);
        if (row) {
          row.scrollIntoView({ behavior: "smooth", block: "center" });
        }
        setTimeout(() => {
          this.highlightedQuoteId = null;
        }, 2500);
      });
    },

    hasWarningItems(quote) {
      return (
        Array.isArray(quote.quote_items) &&
        quote.quote_items.some((item) => item.isWarningItem === true)
      );
    },

    needsRegenPdf(quote) {
      return !!quote.needsRegenPdf;
    },

    async _buildQuotePdf(quoteData, quote, signatureDataUrl = null) {
      const doc = new jsPDF();
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const marginX = 10;
      const marginY = 10;
      const x = marginX;
      let y = marginY;

      try {
        doc.addImage(logoPath, "PNG", x, y, 30, 40);
      } catch (e) {
        console.error("Errore aggiunta logo:", e);
      }

      doc.setFont("helvetica", "normal").setFontSize(9);
      const topRightX = pageWidth - 70;
      let topRightY = y + 5;
      [
        "Viale della libertà 21, 95040 Ramacca ( CT )",
        "P.IVA: 05459100870",
        "SDI: M5UXCR1",
        "amministrazione@4allevent.it",
        "(+39) 3207928979",
      ].forEach((text) => {
        doc.text(text, topRightX, topRightY);
        topRightY += 4;
      });

      const printLabelValue = (label, value, xPos, yPos, maxWidth = null) => {
        doc.setFont("helvetica", "bolditalic").setFontSize(11);
        doc.text(`${label}:`, xPos, yPos);
        const offset = doc.getTextWidth(`${label}: `) + 0.8;
        doc.setFont("helvetica", "normal");
        if (maxWidth) {
          const wrapped = doc.splitTextToSize(
            value || "N/D",
            maxWidth - offset
          );
          wrapped.forEach((ln, idx) =>
            doc.text(ln, xPos + offset, yPos + idx * 5)
          );
          return yPos + wrapped.length * 5;
        } else {
          doc.text(value || "N/D", xPos + offset, yPos);
          return yPos + 5;
        }
      };

      let contentY = y + 55;
      doc
        .setFont("helvetica", "bold")
        .setFontSize(14)
        .text("Dettagli preventivo", x, contentY);
      contentY += 10;

      const loc =
        (() => {
          try {
            return JSON.parse(quoteData.location);
          } catch {
            return { address: quoteData.location };
          }
        })() || {};

      contentY = printLabelValue(
        "Data",
        `inizio ${formatToLocalDate(quoteData.rentStartDate) || "N/D"} - fine ${
          formatToLocalDate(quoteData.rentEndDate) || "N/D"
        } (${quote.daysCount})`,
        x,
        contentY
      );
      contentY = printLabelValue(
        "Cliente",
        quoteData.Client?.clientName || "N/D",
        x,
        contentY
      );
      contentY = printLabelValue(
        "Evento",
        quoteData.eventName || "N/D",
        x,
        contentY
      );
      contentY = printLabelValue("Luogo", loc.address || "N/D", x, contentY);

      if (loc.link) {
        const label = "Link mappa";
        const link = loc.link;
        const cleanLink = link.replace(/^https?:\/\//, "");
        const maxChars = 19;
        const display =
          cleanLink.length > maxChars
            ? cleanLink.slice(0, maxChars) + "…"
            : cleanLink;
        doc.setFont("helvetica", "bolditalic").setFontSize(11);
        doc.text(`${label}:`, x, contentY);
        const offset = doc.getTextWidth(`${label}: `) + 0.8;
        doc
          .setFont("helvetica", "bold")
          .setFontSize(10)
          .setTextColor(0, 0, 255);
        doc.textWithLink(display, x + offset, contentY, { url: link });
        doc.setTextColor(0).setFont("helvetica", "normal").setFontSize(11);
        contentY += 6;
      }

      doc.setDrawColor(150).line(x, contentY, pageWidth - x, contentY);
      contentY += 10;

      const colLeftWidth = pageWidth * 0.6 - 20;
      const colRightWidth = pageWidth * 0.3;

      doc
        .setFillColor(200, 200, 200)
        .rect(x, contentY, colLeftWidth, 10, "F")
        .rect(x + colLeftWidth + 10, contentY, colRightWidth, 10, "F")
        .setFont("helvetica", "bold")
        .setFontSize(11)
        .setTextColor(0, 0, 0)
        .text("Lista articoli", x + 5, contentY + 7)
        .text("Zone", x + colLeftWidth + 15, contentY + 7);

      contentY += 15;

      const items = (quoteData.quote_items || [])
        .filter((qi) => qi.subItem === false)
        .map((qi) => ({
          itemName: qi.item?.itemName,
          quantity: qi.quantity,
          price: qi.price,
          category: qi.item?.category,
          area: qi.area,
          subItem: qi.subItem,
        }));

      const itemsByArea = items.reduce((acc, item) => {
        const area = item.area || "Generale";
        if (!acc[area]) acc[area] = [];
        acc[area].push(item);
        return acc;
      }, {});

      for (const area in itemsByArea) {
        if (!Object.prototype.hasOwnProperty.call(itemsByArea, area)) continue;
        if (contentY > pageHeight - 100) {
          doc.addPage();
          contentY = 15;
        }

        let localY = contentY;
        itemsByArea[area].forEach((item) => {
          const itemName = item.itemName || "N/D";
          const maxWidth = colLeftWidth - 20;

          doc.setFont("helvetica", "normal").setFontSize(10).setTextColor(0);
          const wrappedName = doc.splitTextToSize(`• ${itemName}`, maxWidth);
          doc.text(wrappedName, x + 5, localY);
          const nameBlockHeight = wrappedName.length * 5;

          const detailY = localY + nameBlockHeight + 1;
          const priceIsKnown = !item.subItem;
          const priceValueTxt = priceIsKnown ? String(item.price || 0) : "";
          const priceSepTxt = priceIsKnown ? ` | Prezzo: € ` : ` | N/D`;
          const categoryTxt = `Categoria: ${item.category || "N/D"}`;
          const qtyLabel = `Quantità: `;
          const qtyValue = String(item.quantity || 1);
          const afterPriceTxt = ` | ${categoryTxt}`;

          doc.setFontSize(9).setTextColor(80, 80, 80);
          let curX = x + 10;

          doc.text(qtyLabel, curX, detailY);
          curX += doc.getTextWidth(qtyLabel);

          doc.setTextColor(30, 110, 200).setFont("helvetica", "bold");
          doc.text(qtyValue, curX, detailY);
          curX += doc.getTextWidth(qtyValue);

          doc.setFont("helvetica", "normal").setTextColor(80, 80, 80);
          doc.text(priceSepTxt, curX, detailY);
          curX += doc.getTextWidth(priceSepTxt);

          if (priceIsKnown) {
            doc.setTextColor(30, 110, 200).setFont("helvetica", "bold");
            doc.text(priceValueTxt, curX, detailY);
            curX += doc.getTextWidth(priceValueTxt);
            doc.setFont("helvetica", "normal").setTextColor(80, 80, 80);
          }

          doc.text(afterPriceTxt, curX, detailY);
          doc.setTextColor(0);

          localY += nameBlockHeight + 8;
          if (localY > pageHeight - 30) {
            doc.addPage();
            localY = 15;
          }
        });

        doc
          .setFont("helvetica", "bold")
          .setFontSize(12)
          .text(area.toUpperCase(), x + colLeftWidth + 15, contentY + 5);
        contentY = Math.max(localY, contentY + 50);
        doc.setDrawColor(200).line(x, contentY, pageWidth - x, contentY);
        contentY += 10;
      }

      const footerBlockHeight = 65;
      if (pageHeight - contentY < footerBlockHeight) {
        doc.addPage();
        contentY = marginY;
      }

      doc.setFillColor(240, 240, 240);
      doc.rect(marginX, contentY, pageWidth - 2 * marginX, 55, "F");

      let fy = contentY + 12;
      doc
        .setFont("helvetica", "bold")
        .setFontSize(12)
        .text("Riepilogo", marginX + 8, fy);
      fy += 8;
      doc.setFont("helvetica", "normal").setFontSize(11);
      doc.text(
        `Totale: € ${Number(quote.totalPriceWithoutSubItems || 0).toFixed(2)}`,
        marginX + 8,
        fy
      );

      const centerX = pageWidth / 2;
      let py = contentY + 12;
      doc
        .setFont("helvetica", "bold")
        .setFontSize(12)
        .text("Dettagli pagamento", centerX, py, { align: "center" });
      doc.setFont("helvetica", "normal").setFontSize(10);
      py += 8;
      [
        "IBAN: IT03S0623084153000015064464",
        "Intestato a: 4ALL EVENT SRL",
        "BIC/SWIFT: CRPPIT2PXXX",
        "CRÈDIT AGRICOLE – RAMACCA (CT) 95040 – VIA ROMA 38/40",
      ].forEach((line) => {
        doc.text(line, centerX, py, { align: "center" });
        py += 7;
      });

      const rightPadding = 4;
      const sigEnd = pageWidth - marginX - rightPadding;
      const sigWidth = 32;
      const sigStart = sigEnd - sigWidth;
      doc
        .setFont("helvetica", "bold")
        .setFontSize(11)
        .text("Firma", sigStart, contentY + 12);
      doc.setDrawColor(0).line(sigStart, contentY + 22, sigEnd, contentY + 22);

      // Firma elettronica: embedded sopra la riga firma (tra label e linea)
      if (signatureDataUrl) {
        doc.addImage(
          signatureDataUrl,
          "PNG",
          sigStart,
          contentY + 11,
          sigWidth,
          10
        );
      }

      contentY += 60;

      if (quoteData.technical_queries) {
        if (pageHeight - contentY < 20) {
          doc.addPage();
          contentY = marginY;
        }
        doc.setFont("helvetica", "italic").setFontSize(8);
        const txt = doc.splitTextToSize(
          quoteData.technical_queries,
          pageWidth - 2 * marginX
        );
        doc.text(txt, marginX, contentY);
      }

      const filenameBase = `preventivo_N_${quote.id}.pdf`;
      const isDev =
        process.env.NODE_ENV === "development" ||
        process.env?.VUE_APP_NODE_ENV === "development";
      const withSuffixBeforeExt = (filename, suffix) => {
        if (!suffix) return filename;
        const dot = filename.lastIndexOf(".");
        if (dot <= 0) return `${filename}.${suffix}`;
        return `${filename.slice(0, dot)}.${suffix}${filename.slice(dot)}`;
      };
      const finalName = withSuffixBeforeExt(filenameBase, isDev ? "dev" : "");
      const blob = doc.output("blob");
      const file = new File([blob], finalName, { type: "application/pdf" });
      return { doc, file, finalName };
    },

    async regenQuotePdf(quote) {
      this.regeningPdfFor = quote.id;
      try {
        const response = await axiosInstance.get(`/quote/${quote.id}`);
        const quoteData = response.data.quote;
        const { doc, file, finalName } = await this._buildQuotePdf(
          quoteData,
          quote
        );
        await this.$store.dispatch("uploadQuoteDocument", {
          quoteId: quote.id,
          document: file,
          filename: finalName,
        });
        doc.save(finalName);
        this.toast.success("PDF rigenerato e caricato con successo!");
        await this.getQuotes();
      } catch (error) {
        console.error(error);
        this.toast.error(
          error.response?.data?.details ||
            error.response?.data?.error ||
            "Errore durante la rigenerazione del PDF."
        );
      } finally {
        this.regeningPdfFor = null;
      }
    },

    // Verifica se un articolo è già nella lista danneggiati
    isItemDamaged(itemId) {
      return this.damagedItems.some((item) => item.itemId === itemId);
    },

    // Ottiene l'oggetto danneggiato (o lo crea)
    getDamagedItem(itemId) {
      let damagedItem = this.damagedItems.find(
        (item) => item.itemId === itemId
      );
      if (!damagedItem) {
        damagedItem = { itemId, damagedQuantity: 1 };
        this.damagedItems.push(damagedItem);
      }
      return damagedItem;
    },

    // Gestisce selezione/deselezione articolo
    toggleDamageItem(item) {
      const itemId = item.itemId;
      const isCurrentlyDamaged = this.isItemDamaged(itemId);

      if (isCurrentlyDamaged) {
        // Rimuovi dalla lista
        this.damagedItems = this.damagedItems.filter(
          (di) => di.itemId !== itemId
        );
      } else {
        // Aggiungi alla lista con quantità di default 1
        this.damagedItems.push({
          itemId: itemId,
          damagedQuantity: 1,
          maxQuantity: item.quantity, // Per validazione
        });
      }
    },

    // Calcola il totale degli articoli danneggiati
    getTotalDamagedCount() {
      return this.damagedItems.reduce(
        (total, item) => total + item.damagedQuantity,
        0
      );
    },

    async confirmStateChange() {
      try {
        const payload = { state: this.newState };
        if (this.newState === "Chiuso" && this.damagedItems.length > 0) {
          payload.damagedItems = this.damagedItems.map((item) => ({
            itemId: item.itemId,
            damagedQuantity: item.damagedQuantity,
          }));
        }
        const response = await this.$axios.patch(
          `quote/state/${this.selectedQuoteId}`,
          payload
        );
        console.log("response state: ", response);
        if (response.status === 200) {
          console.log("entro qui?");
          // this.successMessage =
          this.toast.success(
            response.data?.message || "Stato aggiornato con successo."
          );
        }
      } catch (err) {
        // this.errorMessage =
        this.toast.error(
          err.response?.data?.details ||
            err.response?.data?.error ||
            "Errore nell'aggiornamento dello stato."
        );
      } finally {
        this.showStateModal = false;
        this.selectedQuoteId = null;
        this.lowStockItems = [];
        this.getQuotes();
      }
    },

    cancelStateChange() {
      this.showStateModal = false;
      this.selectedQuoteId = null;
      this.lowStockItems = [];
      this.getQuotes();
    },

    cancelDelivery() {
      this.showDeliveryModal = false;
      this.selectedQuoteId = null;
      this.selectedQuote = null;
    },

    openSignModal(doc) {
      this.docToSign = doc;
      this.showSignModal = true;
    },

    async embedAndUpload(signatureDataUrl) {
      this.isSigning = true;
      this.showSignModal = false;
      this.toast.info("Elaborazione firma in corso...");
      try {
        if (!signatureDataUrl || !signatureDataUrl.includes(",")) {
          throw new Error("Formato firma non valido.");
        }
        const quote = this.allQuotes.find(
          (q) => q.id === this.selectedDocQuoteId
        );
        if (!quote) throw new Error("Preventivo non trovato.");

        const response = await axiosInstance.get(
          `/quote/${this.selectedDocQuoteId}`
        );
        const quoteData = response.data.quote;

        const { file, finalName } = await this._buildQuotePdf(
          quoteData,
          quote,
          signatureDataUrl
        );

        await this.$store.dispatch("uploadQuoteDocument", {
          quoteId: this.selectedDocQuoteId,
          document: file,
          filename: finalName,
        });

        this.toast.success("Documento firmato e salvato.");
        await this.getQuotes();
        // Aggiorna selectedDocuments dal store fresco (evita duplicati da ADD_DOC_QUOTE)
        const refreshed = this.allQuotes.find(
          (q) => q.id === this.selectedDocQuoteId
        );
        if (refreshed) {
          this.selectedDocuments = [...(refreshed.documents || [])];
        }
      } catch (err) {
        this.toast.error(
          err.response?.data?.details ||
            err.response?.data?.error ||
            err.message ||
            "Errore durante la firma del documento."
        );
      } finally {
        this.isSigning = false;
        this.docToSign = null;
      }
    },

    async confirmDelivery() {
      try {
        const response = await this.$axios.patch(
          `quote/confirm-delivery/${this.selectedQuoteId}`
        );
        this.toast.success(
          response.data?.message || "Materiale confermato in partenza."
        );
      } catch (err) {
        const msg =
          err.response?.data?.details ||
          err.response?.data?.error ||
          "Errore nella conferma partenza.";
        if (msg.toLowerCase().includes("data di inizio")) {
          const dateStr = this.formatToLocalDate(
            this.selectedQuote?.rentStartDate
          );
          this.toast.error(
            `La data di inizio noleggio non è ancora arrivata (${dateStr}).`
          );
        } else {
          this.toast.error(msg);
        }
      } finally {
        this.showDeliveryModal = false;
        this.selectedQuoteId = null;
        this.selectedQuote = null;
        this.getQuotes();
      }
    },
  },
  mounted() {
    this.getQuotes();
    document.addEventListener("click", this.closeOperatorBadge);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.closeOperatorBadge);
  },
};
</script>

<style scoped src="@/css/QuotePage.css"></style>
